import * as React from 'react';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { ActivityTextAlignment, ActivityTextSize } from '../../../../common/__generated__/api';
var renderTile = function (index, size, text, alignment, margin) {
  return React.createElement(UitkSpacing, {
    margin: margin
  }, React.createElement(UitkHeading, {
    tag: "h2",
    size: size,
    key: "text-tile-".concat(index),
    "data-testid": "activity-text-tile",
    align: alignment
  }, text));
};
export var ActivityTextTile = function (_a) {
  var activityTiles = _a.activityTiles;
  if (activityTiles.length === 0) {
    return null;
  }
  return React.createElement("section", {
    "data-testid": "activity-text-tile-section"
  }, activityTiles.map(function (activityTile, index) {
    var _a;
    var textElement = null;
    var alignment = function (alignment) {
      switch (alignment) {
        case ActivityTextAlignment.CENTRE:
          return 'center';
        case ActivityTextAlignment.LEFT:
          return 'left';
        case ActivityTextAlignment.RIGHT:
          return 'right';
        default:
          return undefined;
      }
    }(activityTile.alignment);
    if ((_a = activityTile.activityText) === null || _a === void 0 ? void 0 : _a.text) {
      switch (activityTile.activityText.size) {
        case ActivityTextSize.LARGE:
          textElement = React.createElement(Viewport, null, React.createElement(ViewSmall, null, renderTile(index, 4, activityTile.activityText.text, alignment, {
            blockend: 'six'
          })), React.createElement(ViewLarge, null, renderTile(index, 3, activityTile.activityText.text, alignment, {
            blockend: 'six'
          })));
          break;
        case ActivityTextSize.MEDIUM:
          textElement = React.createElement(UitkHeading, {
            tag: "h2",
            size: 6,
            key: "text-tile-".concat(index),
            "data-testid": "activity-text-tile",
            align: alignment
          }, activityTile.activityText.text);
          break;
        case ActivityTextSize.SMALL:
        default:
          textElement = React.createElement(UitkText, {
            key: "text-tile-".concat(index),
            size: 200,
            "data-testid": "activity-text-tile",
            align: alignment
          }, activityTile.activityText.text);
      }
    }
    return [textElement];
  }));
};